
const BenefitsSection = () => {
  const benefits = [
    {
      id: "afea3da",
      titleId: "f3ed188",
      textId: "20385a6",
      title: "Jogo Justo",
      content: "Todos os casinos regulamentados utilizam Geradores de Números Aleatórios (RNGs) certificados para garantir resultados justos nos jogos."
    },
    {
      id: "005666d",
      titleId: "46c835e",
      textId: "b29ae7e",
      title: "Proteção do Jogador",
      content: "As regulamentações portuguesas focam-se na segurança do jogador, incluindo medidas de jogo responsável, proteção de dados pessoais e opções de autoexclusão."
    },
    {
      id: "1729fad",
      titleId: "615e793",
      textId: "8f7f65f",
      title: "Transações Seguras",
      content: "Casinos licenciados utilizam protocolos de criptografia de alto nível para proteger as suas informações financeiras e pessoais."
    },
    {
      id: "ba47d70",
      titleId: "0ae8603",
      textId: "e003f2a",
      title: "Garantia Legal",
      content: "Jogar num casino licenciado em Portugal significa que está protegido por lei, com recursos disponíveis caso surjam problemas."
    }
  ];

  return (
    <div className="elementor-element elementor-element-f58291c e-flex e-con-boxed e-con e-parent" data-id="f58291c" data-element_type="container">
      <div className="e-con-inner">
        
        {/* Título Principal */}
        <div className="elementor-element elementor-element-5970d91 elementor-widget elementor-widget-heading" data-id="5970d91" data-element_type="widget" data-widget_type="heading.default">
          <div className="elementor-widget-container">
            <h2 className="elementor-heading-title elementor-size-default">Porque Jogar em Casinos Regulados em Portugal?</h2>
          </div>
        </div>

        {/* Texto de Introdução */}
        <div className="elementor-element elementor-element-88e297e elementor-widget elementor-widget-text-editor" data-id="88e297e" data-element_type="widget" data-widget_type="text-editor.default">
          <div className="elementor-widget-container">
            O mercado de jogos de azar online em Portugal é um dos mais regulamentados da Europa. Ao escolher um casino licenciado pela SRIJ, os jogadores têm a garantia de:
          </div>
        </div>

        {/* Grid de Benefícios */}
        <div className="elementor-element elementor-element-fc523d2 e-con-full e-grid e-con e-child" data-id="fc523d2" data-element_type="container">
          {benefits.map((benefit) => (
            <div 
              key={benefit.id}
              className="elementor-element elementor-element-afea3da e-con-full e-flex e-con e-child" 
              data-id={benefit.id} 
              data-element_type="container" 
              data-settings='{"background_background":"classic"}'
            >
              <div className={`elementor-element elementor-element-${benefit.titleId} elementor-widget elementor-widget-heading`} data-id={benefit.titleId} data-element_type="widget" data-widget_type="heading.default">
                <div className="elementor-widget-container">
                  <h3 className="elementor-heading-title elementor-size-default">{benefit.title}</h3>
                </div>
              </div>
              <div className={`elementor-element elementor-element-${benefit.textId} elementor-widget elementor-widget-text-editor`} data-id={benefit.textId} data-element_type="widget" data-widget_type="text-editor.default">
                <div className="elementor-widget-container">
                  {benefit.content}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Aviso Final */}
        <div className="elementor-element elementor-element-db95162 elementor-widget elementor-widget-text-editor" data-id="db95162" data-element_type="widget" data-widget_type="text-editor.default">
          <div className="elementor-widget-container">
            Nunca jogue em sites sem licença. Use apenas plataformas legais para proteger o seu dinheiro e os seus dados.
          </div>
        </div>

      </div>
    </div>
  );
};

export default BenefitsSection;